




















































































































































































































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MultilevelCategoriesFetcher from "@/components/app/admin/catalogue/products/multilevelCategories/multilevelCategoriesFetchMixin";
import BillingCyclesStore from "@/mixins/constants/billingCyclesStore";
import AdminBrands from "@/mixins/adminBrands";
import CustomFieldsMixin from "@/mixins/customFieldsMixin";
import TagsMixin from "@/mixins/tagsMixin";
import CProdMixin from "@/mixins/cProdMixin";
import { IContractProduct } from "@/models/contracts";
import { IClient } from "@/models/clients";
import { IAccount } from "@/models/accounts";

import {
  ICProdsProviderData,
  ICProdsProviderMethods
} from "@/models/providers/contractProduct";

@Component({
  components: {
    "add-segment-message": () =>
      import("@/components/app/admin/segments/addSegmentMessage.vue"),
    "cprod-status-summary": () =>
      import("@/components/app/global/contractProducts/cProdStatusSummary.vue"),
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class CProdsListingTableView extends Mixins(
  TagsMixin,
  CustomFieldsMixin,
  BillingCyclesStore,
  AdminBrands,
  MultilevelCategoriesFetcher,
  CProdMixin
) {
  @Inject({ from: "cProdsProvider" })
  public cProdsProvider!: () => ICProdsProviderData;

  @Inject({ from: "cProdsProviderMethods" })
  public $cProdsMethods!: ICProdsProviderMethods;

  // Prop

  @Prop({ default: "u-contract-product-link" })
  public rowTag!: string;

  @Prop({ default: false })
  public isSubscription!: boolean;

  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: null })
  public accountId!: IAccount["id"];

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (
    contractProduct: IContractProduct
  ) => { [key: string]: Function };

  @Prop({ default: true })
  public showWhenPurchased!: boolean;

  // Computed

  public get $cProdsData() {
    return this.cProdsProvider();
  }

  public get table() {
    return this.$cProdsData.table;
  }

  public hasUnresolvedRequests(cProd) {
    return !!cProd.unresolved_provision_requests?.length;
  }
}
